/* eslint-disable no-lone-blocks */
import React, { Component } from "react"
// import NavBar from "./navbar/navbar"
// import { Row, Col, Empty, Table, Card, Icon } from "antd"
import { Link } from "react-router-dom"
import "./Home.scss"
import { Carousel } from "react-bootstrap"
import ScrollIntoView from "react-scroll-into-view"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faEthereum } from "@fortawesome/free-brands-svg-icons"
import {
	faCreditCard,
	faArrowRight,
	faArrowDown,
	faQuestionCircle,
	faAddressBook,
	faBookOpen,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import AppFooter from "./footer/footer"
import AboutVideoModal from '../modals/AboutVideoModal'
import NavBarTest from "./navbar/NavBarTest";

// const { Meta } = Card

library.add(
	faCreditCard,
	faArrowRight,
	faArrowDown,
	faEthereum,
	faQuestionCircle,
	faAddressBook,
	faBookOpen
);

class Home extends Component {
	constructor(props) {
		super(props)
		this.state = {
			cryptodata: [],
			news: [],
			videomodalOpen:false
		}

		this.myElement = null
	}

	// async getCryptoData() {
	// 	let data = await CryptoCoinsOnHome()

	// 	this.setState({
	// 		cryptodata: data,
	// 	})
	// }

   handleVideoModelOpen() {
		this.setState({
			videomodalOpen: true,
		})
	}
	handleVideoModelClose() {
		this.setState({
			videomodalOpen: false,
		})
	}
	async componentDidMount() {
		// const News = await NewsApi()
		// this.setState({
		// 	news: News,
		// })
		// this.getCryptoData()
		// this.intervalID = setInterval(this.getCryptoData.bind(this), 5000)
	}

	componentWillUnmount() {
		clearInterval(this.intervalID)
	}

	render() {
		// const props = this.props

		return (
			<div>
				<NavBarTest />
				{/*<NavBar />*/}
				<div className='position-relative'>
					<div className='' style={{width: '88vw', margin: 'auto'}}>
						<div className='row justify-content-lg-between height-lg-100vh'>
							<div className='col-lg-5 d-flex align-items-center align-self-lg-center min-height-600 min-height-lg-auto'>
								<div className='position-relative z-index-2'>
									<div className='mb-7'>
										<span className='d-none d-sm-block btn btn-lg btn-icon btn-white text-primary rounded-circle mb-4'>
											<FontAwesomeIcon
												icon={faCreditCard}
												className='mb-0 btn-icon__inner'
											/>
										</span>
										<h1 className='font-size-md-down-5 text-white font-weight-semi-bold'>
											{" "}
											<span className='text-warning'>
												The Zimble
											</span>
										</h1>
										<p style={{fontWeight: '500'}} className='lead text-white-70'>
											Revolutionizing education in the
											wake of the Coronavirus pandemic.
										</p>
										<iframe
											className="mt-3"
											width='100%'
											height='290'
											title="about video"
											src='https://www.youtube.com/embed/VGhwtJXWRcw'
											frameBorder='0'
											allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
											allowFullScreen
										></iframe>
										{/* <img onClick={()=>this.handleVideoModelOpen()}height="70px" width="70px" src={require('../icons/play-circle-twotone.svg')} alt="see video"></img><span onClick={()=>this.handleVideoModelOpen()} style={{color:'#ffffff'}}>Watch Video</span> */}
									</div>

									{/* <Link className='btn btn-warning transition-3d-hover' to='/platform'>
										<span
											style={{ color: "white" }}
											
										>
											{" "}
											How to use Zimble
										</span>
									</Link> */}
								</div>
							</div>

							<div className='col-lg-5 align-self-center space-2 space-md-3 space-lg-0'>
								<Carousel controls={false} indicators={false}>
									<Carousel.Item>
										<div>
											<div className='text-center mb-7'>
												<span className='btn btn-icon btn-soft-primary rounded-circle mb-4'>
													<span className='small font-weight-semi-bold btn-icon__inner'>
														01.
													</span>
												</span>
												<h2 className='h4 text-primary'>
													Learn about the Zimble
												</h2>
												<p>
													Zimble is a question,
													answer, and video sharing
													platform for students; where
													questions can be asked,
													answered, and educational
													videos can be uploaded by
													our users.
												</p>
											</div>

											<figure className='ie-vault'>
												<img
													className='js-svg-injector img-fluid'
													src={require("../images/image1.PNG")}
													alt='Learn about Kyama'
													data-parent='#SVGvault'
												/>
											</figure>
										</div>
									</Carousel.Item>
									<Carousel.Item>
										<div>
											<div className='text-center mb-7'>
												<span className='btn btn-icon btn-soft-primary rounded-circle mb-4'>
													<span className='small font-weight-semi-bold btn-icon__inner'>
														02.
													</span>
												</span>
												<h2 className='h4 text-primary'>
													What makes us unique
												</h2>
												<p>
													What makes this platform
													unique is that it is created
													by people for people. This
													strategy gives the user a
													global world view to 
													learning and access to many
													different teaching styles,
													cultures, and languages in
													their own native content.
												</p>
											</div>

											<figure className='ie-vault'>
												<img
													className='js-svg-injector img-fluid'
													src={require("../images/image2.PNG")}
													alt='Link your blockchain wallet'
													data-parent='#SVGvault'
												/>
											</figure>
										</div>
									</Carousel.Item>
									<Carousel.Item>
										<div>
											<div className='text-center mb-7'>
												<span className='btn btn-icon btn-soft-primary rounded-circle mb-4'>
													<span className='small font-weight-semi-bold btn-icon__inner'>
														03.
													</span>
												</span>
												<h2 className='h4 text-primary'>
													Our Goal
												</h2>
												<p>
													At Zimble our goal is to
													spark curiosity, foster
													innovation, allow creative
													thinking, and learning for
													students by exposing them to
													educational materials by
													educators from around the
													world.
												</p>
											</div>

											<figure className='ie-vault'>
												<img
													style={{maxHeight: 320}}
													className='js-svg-injector img-fluid'
													src={require("../images/undraw_Brainstorming_akrv.svg")}
													alt='Enjoy low-risk personal loans'
													data-parent='#SVGvault'
												/>
											</figure>
										</div>
									</Carousel.Item>
								</Carousel>
							</div>
						</div>
					</div>

					<ScrollIntoView selector='#graphicsSection'>
						<div id="homeScrollToButton" style={{top: '-40px !important'}} className=' d-lg-block position-absolute right-0 bottom-0 left-0 text-center mb-5'>
							<button className='js-go-to u-go-to-modern'>
								<FontAwesomeIcon
									icon={faArrowDown}
									className='mb-0 u-go-to-modern__inner'
								/>
							</button>
						</div>
					</ScrollIntoView>

					<div className='col-lg-6 gradient-half-primary-v1 position-absolute top-0 left-0 min-height-600 height-lg-100vh'></div>
				</div>

				{/* <Container>
					<HomeCoins />
				</Container> */}

				<div
					id='graphicsSection'
					className='gradient-overlay-half-primary-v1 bg-img-hero'
				>
					<div
						style={{ marginTop: 30 }}
						className='container space-2'
					>
						<div className='row align-items-md-center'>
							<div className='col-md-8 mb-7 mb-md-0'>
								<div className='media'>
									<span className='btn btn-lg btn-icon btn-soft-light rounded-circle mr-4'>
										<FontAwesomeIcon
											icon={faQuestionCircle}
											className='btn-icon__inner mb-0'
										/>
									</span>
									<div className='media-body'>
										<h2 className='text-white font-weight-semi-bold'>
											What We{" "}
											<span className='text-warning'>
												Do?
											</span>
										</h2>
										<p className='text-white-70 mb-0'>
											{" "}
											On Zimble, everyone is an educator. Our goal is to spark curiosity, foster innovation, allow creative thinking, and learning for students by exposing them to educational materials by educators from around the world. Providing content from educators from around the world will give students access to various cultural styles, teaching models, and world views that will assist in shaping them academically.
										</p>
									</div>
								</div>
							</div>
							 <div className="col-md-4 text-md-right">
                            <Link className="btn btn-warning transition-3d-hover" to="/about">
                             About Us
                            </Link>
							 <Link style={{marginLeft:10}} className="btn btn-warning transition-3d-hover" to="/team">
                                Meet the Team
                            </Link>
                        </div>
						</div>
					</div>
				</div>

				<div className='container space-2'>
					<div className='row align-items-lg-center'>
						<div className='col-lg-5 mb-7 mb-lg-0'>
							<div className='pr-lg-4'>
								<span className='btn btn-icon btn-soft-primary rounded-circle mb-3'>
									<span className='small font-weight-semi-bold btn-icon__inner'>
										01.
									</span>
								</span>
								<h2 className='h4 font-weight-semi-bold text-primary'>
									Education made Simple
								</h2>
								<p className='mb-0'>
									We manage the provision of content from
									educators from around the world in order to
									give students access to various cultural
									styles, teaching models, and world views
									that will not only assist them but shape
									them academically.
								</p>
							</div>
						</div>

						<div id='SVGmarketingStrategy' className='col-lg-7'>
							<figure className='ie-marketing-strategy'>
								<img
									className='js-svg-injector img-fluid'
									src={require("../images/undraw_exams_g4ow.svg")}
									alt='Indefinite payment periods.'
									data-parent='#SVGmarketingStrategy'
								/>
							</figure>
						</div>
					</div>

					<div className='container space-2'>
						<div className='row align-items-lg-center'>
							<div className='col-lg-5 order-lg-2 mb-7 mb-lg-0'>
								<div className='pl-lg-4'>
									<span className='btn btn-icon btn-soft-primary rounded-circle mb-3'>
										<span className='small font-weight-semi-bold btn-icon__inner'>
											02.
										</span>
									</span>
									<h2 className='h4 font-weight-semi-bold text-primary'>
										Content Creation made easier
									</h2>
									<p className='mb-0'>
										Our platform allows content creators to
										create video content for students on
										various topics.The content is monitored
										based on quality and relevance.
									</p>
								</div>
							</div>

							<div
								id='SVGappDevelopment'
								className='col-lg-7 order-lg-1'
							>
								<figure className='ie-app-development'>
									<img
										className='js-svg-injector img-fluid'
										src={require("../images/undraw_Bibliophile_hwqc.svg")}
										alt='Earn interest on savings.'
										data-parent='#SVGmarketingStrategy'
									/>
								</figure>
							</div>
						</div>
					</div>

					<div className='container space-2'>
						<div className='row align-items-lg-center'>
							<div className='col-lg-5 mb-7 mb-lg-0'>
								<div className='pr-lg-4'>
									<span className='btn btn-icon btn-soft-primary rounded-circle mb-3'>
										<span className='small font-weight-semi-bold btn-icon__inner'>
											03.
										</span>
									</span>
									<h2 className='h4 font-weight-semi-bold text-primary'>
										Q&A capabilities
									</h2>
									<p className='mb-0'>
										Students can ask questions on specific
										topics and get answers from anyone with
										answer to their questions.
									</p>
								</div>
							</div>

							<div id='SVGbusinessAnalysis' className='col-lg-7'>
								<figure className='ie-business-analysis'>
									<img
										className='js-svg-injector img-fluid'
										src={require("../images/undraw_online_test_gba7.svg")}
										alt='With all blockchain perks'
										data-parent='#SVGmarketingStrategy'
									/>
								</figure>
							</div>
						</div>
					</div>
				</div>

				<div className='gradient-half-primary-v1'>
					<div className='container space-2'>
						<div className='media d-block d-md-flex'>
							<div className='u-lg-avatar mr-md-7 mb-7 mb-md-0'>
								<span className='btn btn-lg btn-icon btn-soft-light rounded-circle mr-4'>
									<FontAwesomeIcon
										icon={faBookOpen}
										className='btn-icon__inner mb-0'
									/>
								</span>
							</div>
							<div className='media-body'>
								<blockquote className=' text-white '>
									In 2020 we witnessed the world come to an
									alarming standstill as a result of COVID-19.
									Sports and schools shut down, millions of
									jobs lost, all social gatherings became
									extinct virtually overnight. There are
									millions of children in many countries that
									were adversely affected by school closures
									due to the COVID-19 situation. For students
									in developing countries, the impacts were
									not as drastic as it was in non-developed
									countries. When schools get shut down
									children who have the privilege of going to
									school end up having to stay without
									education for many months. However even in
									times without pandemic shutdowns, many
									children in rural poverty do not have access
									to an education which is a tragedy within
									itself. It's time to come together and spark
									a movement to end this educational drought
									to those that need it most. We are calling
									all educators from across the globe to share
									with the student of the world, creative ways
									to explain any educational topics or
									creative ways to solve a math problem, and
									well-thought best practices to teach
									students.
								</blockquote>
								{/* <h4 className='h5 text-white'>Eric Schmidt,</h4>
								<span className='d-block text-warning pl-3'>
									&#8212; CEO, Google.
								</span> */}
							</div>
						</div>
					</div>
				</div>

				<div className='container space-2'>
					<div className='w-md-80 w-lg-65  mx-md-auto mb-9'>
						<h2 className='text-primary text-center font-weight-semi-bold'>
                         How you can help						</h2>
						<p>If you are the kind of person that would love to help create educational content and best practices to help teach, motivate, and engage zimble students around the world, this platform is for you.</p>

						<ul className="a">
						<li>Publish home recording of you teaching a topic or subject that you are passionate about. </li>
						<li>Upload the best creative ways you figured how a problem or a topic can be solved or explained. </li>
						<li>Answer questions students may have.</li>
						</ul>
						<p>You can help teach students around the world and help them keep up with school while they stay at home. </p>
					</div>
				</div>

				<div className='gradient-half-primary-v1'>
					<AppFooter />
				</div>


				<AboutVideoModal
					isOpen={this.state.videomodalOpen}
					onOpenModal={this.handleVideoModelOpen}
					onCloseModal={() => this.handleVideoModelClose()}
				/>
			</div>


			
		)
	}
}

export default Home
